import { render, staticRenderFns } from "./MeetingActionCustomMenuButton.vue?vue&type=template&id=55a3969a&scoped=true&"
import script from "./MeetingActionCustomMenuButton.vue?vue&type=script&lang=js&"
export * from "./MeetingActionCustomMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./MeetingActionCustomMenuButton.vue?vue&type=style&index=0&id=55a3969a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a3969a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55a3969a')) {
      api.createRecord('55a3969a', component.options)
    } else {
      api.reload('55a3969a', component.options)
    }
    module.hot.accept("./MeetingActionCustomMenuButton.vue?vue&type=template&id=55a3969a&scoped=true&", function () {
      api.rerender('55a3969a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MeetingActionCustomMenuButton.vue"
export default component.exports